import { useSelector } from 'react-redux';
import * as selectors from '../../../modules/accessSettings/selectors';
import * as siteSelectors from '../../../modules/sites/selectors';

export function useGetApartmentFormData() {
  const { isLoading, optionsData } = {
    isLoading: useSelector(selectors.isAddAccessGroupApartmentsFetching),
    optionsData: useSelector(selectors.getAccessControlApartmentsFiltered),
  };

  return {
    isLoading,
    optionsData,
  };
}
